(function ($, njm) {
    'use strict';

    njm.views.userGuide = Backbone.View.extend({

        events: {
            "change input": "checkValue",
			"click button.button, button.back": "buttonNavigate",
            "click .file-claim": "fileAClaim",
        },

        /**
         * Initialize
         */
        initialize: function () {
			var $this = this;
			
			$(document).ready(function(){
				setTimeout($this.startChecked, 100);
			});
			
			
        },
		
		startChecked: function(){
				var checked = this.$('[data-key="start"] input:checked');

				if ( checked.length === 1 ) {
					checked.trigger('change');
				}
		},
		
        checkValue: function (event) {
			
			var $el = $(event.target),
				val = $el.val(),
				$currentScreen = $el.closest('.screen'),
				currentScreenData = $currentScreen.data('screen'),
				targetScreenData,
				sameScreen,
				options = [],
				radioName;
			
			//find if target element is in same screen as current question
			targetScreenData = this.$('[data-key=' + val + ']').closest('.screen').data('screen');
			sameScreen = ( currentScreenData === targetScreenData );
			
			//gather options for current input
			if ($el.attr('type') === 'radio') {
				radioName = $el.attr('name');
				
				this.$('[name=' + radioName + ']').each(function(){
					options.push($(this).val());
				})
				
			}
			
			if (sameScreen) {
				
				//disable continue button
				$currentScreen.find('button.button').attr('disabled','disabled').removeAttr('data-target');
				
				//hide all options for current input
				this.hideEls(options);

				//display selected option for current input value
				this.showEl(this.$('[data-key=' + val + ']'));
				
			} else if (!sameScreen) {
				//hide all options for current input
				this.hideEls(options);

				//enable and populate continue button
				$currentScreen.find('button.button').removeAttr('disabled').attr('data-target',val);
			}
				
        },
		
		hideEls: function(elList) {
			var el, elChecked, elSecondaryList = [];
			
			
			if (elList.length > 1) {
				
				for (var i = 0; i < elList.length; i++) {
					el = this.$('[data-key=' + elList[i] + ']');
					el.hide();
					
					elChecked = el.find('input:checked');
					
					if (elChecked.length === 1) {
						elSecondaryList.push(elChecked.val());
					}
				}
				
				if (elSecondaryList.length > 0) {
					this.hideEls(elSecondaryList);
				}
				
			} else if (elList.length === 1) {
				
				this.$('[data-key=' + elList + ']').hide();
				
			}
			
		},
		
		showEl: function($el) {
			var $elChecked = $el.find('input:checked');
			
			$el.fadeIn(500).removeClass('hidden');
			
			if ($elChecked.length === 1) {
				$elChecked.trigger('change');
			}
		},
		
		
		
		buttonNavigate: function (event) {
			
			var $this = this,
				$target = $(event.target),
				targetData = $target.attr('data-target'),
				$targetScreen = this.$('[data-screen=' + targetData + ']'),
				$currentScreen = $target.closest('.screen');
			
			
			//hide current screen and display next screen
			$currentScreen.fadeOut(function(){
				$targetScreen.fadeIn().removeClass('hidden');
				$this.scrollToTop();
			});
			
			//populate back screen target
			if ($targetScreen.find('button.back').length > 0) {
				$targetScreen.find('button.back').attr('data-target',$currentScreen.data('screen'));
			}
		},
		
		topIsVisible: function () {
			//measure if the top of the userGuide element is visible
			var winTop = $(window).scrollTop(),
				elTop = this.$el.offset().top;

			return (elTop > winTop);
		},
		
		scrollToTop: function () {
			var $this = this;
			
			if (!this.topIsVisible()) {
				//if top is not visible, scroll up to make the top visible
				$([document.documentElement, document.body]).animate({
					scrollTop: $this.$el.offset().top
				}, 500);
			}
        },
        fileAClaim: function (e) {
            var claimType = $(e.currentTarget).data('claim-type');
            sessionStorage.ClaimFor = claimType;
            sessionStorage.FromClaimPage = 'true';
		}
    });
})(jQuery, njm);
